var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentLoader',{class:_vm.$style.content,attrs:{"width":310,"height":76,"speed":1}},[_c('rect',{attrs:{"x":"81","y":"20","rx":"0","ry":"0","width":"150","height":"15"}}),_c('rect',{attrs:{"x":"81","y":"46","rx":"0","ry":"0","width":"190","height":"12"}}),_c('circle',{attrs:{"cx":"42","cy":"42","r":"30"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }